export default {
  title: 'Profiili',
  fields: {
    name: {
      label: 'Nimi',
      placeholder: 'Anna ravintolan nimi',
    },
    short_name: {
      label: 'Lyhyt nimi',
      placeholder: 'Anna ravintolan lyhyt nimi',
      tooltip:
        'Joskus ravintolan oletusnimet ovat hyvin pitkiä ja voivat sisältää lisätietoja, joten joissain tapauksissa (esim. lyhyemmät ilmoitukset) tarvitaan nimestä lyhyempi versio',
    },
    phone_number: {
      label: 'Puhelinnumero',
      placeholder: 'Anna ravintolan puhelinnumero',
    },
    email: {
      label: 'Sähköposti',
      placeholder: 'Anna ravintolan sähköposti',
    },
    slug: {
      label: 'Lyhytosoite',
      placeholder: 'Brändin lyhytosoite',
    },
    language: {
      label: 'Kieli',
      placeholder: 'Käytä ryhmän oletusta',
      tooltip:
        'Kieli, jonka asiakkaat näkevät tämän ravintolan Storefrontissa, ja henkilökunnan oletuskieli. Jätä tyhjäksi noudattaaksesi brändin kieltä. Henkilökunta voi silti valita oman kielensä omaan näkymäänsä.',
    },
    sms_name: {
      label: 'SMS-nimi',
      placeholder: 'SMS-näyttönimi',
    },
    instagram_link: {
      label: 'Instagram-linkki',
      placeholder: 'Anna ravintolan Instagram-linkki',
    },
    website_link: {
      label: 'Verkkosivun linkki',
      placeholder: 'Anna ravintolan verkkosivun linkki',
    },
    impressum_link: {
      label: 'Yritystietojen linkki',
      placeholder: 'Anna ravintolan yritystietojen linkki',
    },
    timezone: {
      label: 'Aikavyöhyke',
      placeholder: 'Hae kaupunkia tai aikavyöhykettä',
      tooltip:
        'Aikavyöhyke, jossa tämä ravintola toimii. Se vaikuttaa tilausten aikaleimoihin, aukioloaikoihin ja ajastettuihin tilausaikoihin. Se asetettiin ravintolan osoitteen perusteella ravintolaa luotaessa — korjaa tästä, jos se on väärin.',
    },
    time_format: {
      label: 'Aikamuoto',
      placeholder: 'Käytä maan oletusta',
      tooltip:
        'Miten kellonajat näytetään tiimillesi hallintapaneelissa ja tilausportaalissa. Jätä tyhjäksi noudattaaksesi ravintolan alueen käytäntöä.',
      options: {
        '12h': '12 tuntia (5:30 ip.)',
        '24h': '24 tuntia (17:30)',
      },
    },
    primary_color: {
      label: 'Pääväri',
    },
    restaurant_type: {
      label: 'Ravintolatyyppi ja palvelumalli',
    },
    cuisine_types: {
      label: 'Ruokalajit ja keittiötyypit',
    },
  },
  test_restaurant: {
    title: 'Testiravintola',
    description:
      'Tee tästä testiravintolasi kokeillaksesi tulostusta, sähköposteja, tilauksia ja integraatioita tuotannossa. Se toimii kuten mikä tahansa muu ravintola eikä siitä koskaan laskuteta. Voit pitää vain yhden testiravintolan.',
    description_test:
      'Tämä on testiravintolasi. Se toimii kuten mikä tahansa muu ravintola eikä siitä koskaan laskuteta. Sen tilauksia koskevat asiakkaiden sähköpostit ja tekstiviestit alkavat merkinnällä [TEST].',
    mark: 'Merkitse testiravintolaksi',
    remove: 'Poista testimerkintä',
    slot_taken: 'Sinulla on jo testiravintola ({{name}}). Poista ensin testimerkintä nykyisestä ravintolastasi.',
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    info_updated: 'Asetukset päivitettiin onnistuneesti',
  },
};
